module.exports = __webpack_public_path__ + "img/dpi-background-motif.96349919.png";